import { RentalManagerBrowserEnvironment } from '@zg-rentals/rental-manager-env-base';

export { useSetName } from './useSetName';
export { useGetNames } from './useGetNames';
export { useCreateProperty } from './useCreateProperty';
export { useGetProperties } from './useGetProperties';
export { useCreateCappsUser } from './useCreateCappsUser';
export { useSendTenantScreeningInvitation } from './useSendApplicationInvitation';
export { useMarkTermsAccepted } from './useMarkTermsAccepted';

export type { SetNameRequest } from './useSetName';
export type { GetNamesRequest, UserProfileInfo, GetNamesResponse } from './useGetNames';
export type { CreatePropertyRequest, CreatePropertyResponse } from './useCreateProperty';
export type { PropertyListing, GetPropertiesResponse } from './useGetProperties';
export type { CreateCappsUserRequest } from './useCreateCappsUser';
export type { SendInvitationRequest } from './useSendApplicationInvitation';

export const environment = process.env.NEXT_PUBLIC_LOCAL_BASE_URL
  ? process.env.NEXT_PUBLIC_LOCAL_BASE_URL
  : `${typeof window !== 'undefined' ? window.location.origin : ''}/`;

// TODO - Once tenant screening services API is migrated to proxit this will not be needed
// @ts-ignore
RentalManagerBrowserEnvironment.setInstance({
  brand: 'zillow',
  // @ts-ignore
  nodeEnv: {
    brand: 'zillow',
    zgApi: environment,
  },
  isClient: true,
  isServer: false,
});
